import React from 'react';
import './page404.css';

const Page404 = (props) => {

  return (
    <div className="Page404Page">
      <h3>404</h3>
      <h1>Page Not Found</h1>
    </div>
  );

};

export default Page404;


// WEBPACK FOOTER //
// ./src/components/universal/page404/page404.js